export default {
  actualSetpoint: 'Aktuálna žiadaná',
  actualValue: 'Aktuálna hodnota',
  copySetpointsFromRecipe: 'Skopírovať nastavené hodnoty z receptu',
};
